import { createContext } from 'react';

export const ActivityContext = createContext();
